import type { IColumns } from "@/components/Base/BaseTable.vue";

export interface IBaseColumns extends IColumns {}

export const tenantRentColumns: IBaseColumns[] = [
  {
    title: "Ay",
    key: "month",
    width: "minmax(145px,1fr)",
  },
  {
    title: "Kira",
    key: "amount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Ödenen Kira",
    key: "payAmount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Kalan Kira",
    key: "remainAmount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Aidat",
    key: "subscriptionAmountTl",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Ödenen Aidat",
    key: "subscriptionPayAmountTl",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Kalan Aidat",
    key: "subscriptionRemainAmountTl",
    width: "minmax(135px,1fr)",
  },
  { title: "Durum", key: "stateText", width: "minmax(135px,1fr)" },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "minmax(360px,1fr)",
  },
];

export const tenantStoreRentColumns: IBaseColumns[] = [
  {
    title: "Ay",
    key: "month",
    width: "minmax(145px,1fr)",
  },
  {
    title: "Kira",
    key: "amount",
    width: "minmax(120px,1fr)",
  },
  {
    title: "Ödenen Kira",
    key: "payAmount",
    width: "minmax(120px,1fr)",
  },
  {
    title: "Kalan Kira",
    key: "remainAmount",
    width: "minmax(120px,1fr)",
  },
  { title: "Durum", key: "stateText", width: "minmax(120px,1fr)" },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "minmax(270px,1fr)",
  },
];

export const activitiesColumns: IBaseColumns[] = [
  {
    title: "İşlem Tutarı",
    key: "amount",
    width: "140px",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(280px,3fr)",
  },
  {
    title: "Oluşturulma Tarihi",
    key: "createdAt",
    width: "190px",
  },
  {
    title: "İşlem Yapan",
    key: "operatorBy",
    width: "150px",
  },
];

// Kişi hareketleri: yalnızca ödeme planındaki tutar değişikliklerinde "Sil" çıkar.
export const tenantActivitiesColumns: IBaseColumns[] = [
  ...activitiesColumns,
  { title: "Aksiyonlar", key: "action", fixed: "right", width: "110px" },
];

export const activitiesColumnsWithActions: IBaseColumns[] = [
  {
    title: "İşlem Tutarı",
    key: "amount",
    width: "140px",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(170px,3fr)",
  },
  {
    title: "Oluşturulma Tarihi",
    key: "createdAt",
    width: "190px",
  },
  {
    title: "İşlem Yapan",
    key: "operatorBy",
    width: "150px",
  },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "300px",
  },
];

export const subExpensesColumns: IBaseColumns[] = [
  {
    title: "Alt Gider Kalem Adı",
    key: "name",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Cari Hesap",
    key: "openAccount",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Borç $",
    key: "debtAmountUsd",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Borç ₺",
    key: "debtAmountTl",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Gider $",
    key: "amountUsd",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Gider ₺",
    key: "amountTl",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "minmax(160px,1fr)",
  },
];

export const invoicesColumns: IBaseColumns[] = [
  {
    title: "Fatura No",
    key: "invoiceNo",
    width: "minmax(120px,1fr)",
  },
  {
    title: "Fatura Tarihi",
    key: "invoiceDate",
    width: "minmax(140px,1fr)",
  },
  {
    title: "Fatura Tutarı",
    key: "invoiceAmount",
    width: "minmax(120px,1fr)",
  },
  {
    title: "Ödenen Tutar",
    key: "payedInvoiceAmount",
    width: "minmax(120px,1fr)",
  },
  {
    title: "Kalan Tutar",
    key: "remainedInvoiceAmount",
    width: "minmax(120px,1fr)",
  },
  { title: "Durum", key: "status", width: "minmax(120px,1fr)" },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "minmax(170px,1fr)",
  },
];

export const bankColumns: IBaseColumns[] = [
  { title: "Kasa", key: "bankName", width: "minmax(150px,1.2fr)" },
  {
    title: "Toplam Devir",
    key: "totalCycleAmount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Toplam Virman",
    key: "totalTransferAmount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Toplam Gelir",
    key: "totalDepositAmount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Toplam Gider",
    key: "totalWithdrawAmount",
    width: "minmax(135px,1fr)",
  },
  {
    title: "Toplam Bakiye",
    key: "totalBalance",
    width: "minmax(135px,1fr)",
  },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: 132 },
];

export const dashboardBankColumns: IBaseColumns[] = [
  { title: "Kasa", key: "bankName", width: "minmax(160px,1fr)" },
  {
    title: "Toplam Bakiye",
    key: "totalBalance",
    width: "minmax(160px,1fr)",
  },
];

export const tenantColumns: IBaseColumns[] = [
  { title: "Ad Soyad", key: "nameSurname", width: "minmax(240px,1.4fr)" },
  {
    title: "Cep Telefonu",
    key: "phoneNumber",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Mağaza",
    key: "propertyName",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Depo",
    key: "storeName",
    width: "minmax(160px,1fr)",
  },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: 132 },
];

export const pastTenantRentColumns: IBaseColumns[] = [
  { title: "Mağaza/Depo", key: "name", width: "minmax(140px,1fr)" },
  { title: "Ay", key: "month", width: "minmax(120px,1fr)" },
  { title: "Kalan Kira", key: "remainAmount", width: "minmax(130px,1fr)" },
  {
    title: "Kalan Aidat",
    key: "remainSubscriptionAmountTl",
    width: "minmax(130px,1fr)",
  },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "minmax(230px,1fr)",
  },
];

export const pastPaymentColumns: IBaseColumns[] = [
  { title: "Tarih", key: "createdAt", width: "minmax(190px,1fr)" },
  { title: "Mağaza/Depo", key: "name", width: "minmax(150px,1fr)" },
  { title: "Kategori", key: "category", width: "minmax(150px,1fr)" },
  { title: "Tutar", key: "amount", width: "minmax(120px,1fr)" },
  { title: "Makbuz No", key: "no", width: "minmax(110px,1fr)" },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: "minmax(190px,1fr)" },
];

export const formerTenantDebtColumns: IBaseColumns[] = [
  { title: "Kişi", key: "nameSurname", width: "minmax(180px,1.2fr)" },
  { title: "Mağaza/Depo", key: "unitName", width: "minmax(170px,1fr)" },
  { title: "Borçlu Aylar", key: "debtMonths", width: "minmax(200px,1.3fr)" },
  { title: "Kalan Kira", key: "remainAmount", width: "minmax(130px,1fr)" },
  {
    title: "Kalan Aidat",
    key: "remainSubscriptionAmountTl",
    width: "minmax(130px,1fr)",
  },
  { title: "Son Tahsilat", key: "lastPaymentDate", width: "minmax(130px,1fr)" },
];

export const tenantRentManagementColumns: IBaseColumns[] = [
  {
    title: "",
    key: "selection",
    width: "56px",
    justify: "center",
    bodyJustify: "center",
  },
  {
    title: "Numara",
    key: "propertyOrStoreName",
    width: "minmax(120px,0.6fr)",
  },
  {
    title: "Tip",
    key: "rentType",
    width: "minmax(80px,0.5fr)",
  },
  { title: "Ad Soyad", key: "nameSurname", width: "minmax(160px,1fr)" },
  {
    title: "Kira Tutarı",
    key: "rentAmount",
    width: "minmax(140px,1fr)",
  },
  {
    title: "Aidat Tutarı",
    key: "subscriptionAmount",
    width: "minmax(140px,1fr)",
  },
  {
    title: "Aksiyonlar",
    key: "action",
    fixed: "right",
    width: "minmax(190px,1fr)",
  },
];

export const reportColumns: IBaseColumns[] = [
  { title: "İşlem Tarihi", key: "date", width: "200px" },
  {
    title: "Seri No",
    key: "no",
    width: "100px",
  },
  {
    title: "Mağaza/Depo",
    key: "type",
    width: "150px",
  },
  {
    title: "Kategori",
    key: "paymentType",
    width: "170px",
  },
  {
    title: "Ad Soyad",
    key: "tenant",
    width: "250px",
  },
  {
    title: "Şirket",
    key: "company",
    width: "250px",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Kasa",
    key: "bankName",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Tutar",
    key: "amount",
    width: "150px",
  },
];

export const bankReportColumns: IBaseColumns[] = [
  { title: "İşlem Tarihi", key: "date", width: "190px" },
  {
    title: "Kasa",
    key: "bankName",
    width: "140px",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(280px,3fr)",
  },
  {
    title: "Tutar",
    key: "amount",
    width: "140px",
  },
  {
    title: "Toplam Bakiye",
    key: "totalBalance",
    width: "150px",
  },
];

export const expenseReportColumns: IBaseColumns[] = [
  { title: "İşlem Tarihi", key: "date", width: "210px" },
  {
    title: "Seri No",
    key: "no",
    width: "130px",
  },
  {
    title: "Gider Kalemi",
    key: "expenseName",
    width: "210px",
  },
  {
    title: "Alt Gider Kalemi/Cari Hesap",
    key: "subExpenseName",
    width: "250px",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Tutar",
    key: "amount",
    width: "200px",
  },
];

export const revenueReportColumns: IBaseColumns[] = [
  { title: "İşlem Tarihi", key: "date", width: "210px" },
  {
    title: "Seri No",
    key: "no",
    width: "130px",
  },
  {
    title: "Gelir Kalemi",
    key: "revenueName",
    width: "250px",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Tutar",
    key: "amount",
    width: "200px",
  },
];

export const reportTenantColumns: IBaseColumns[] = [
  { title: "İşlem Tarihi", key: "date", width: "minmax(160px,1fr)" },
  {
    title: "Seri No",
    key: "no",
    width: "100px",
  },
  {
    title: "Mağaza/Depo",
    key: "type",
    width: "120px",
  },
  {
    title: "Kategori",
    key: "paymentType",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Ad Soyad",
    key: "tenant",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Açıklama",
    key: "description",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Ay",
    key: "month",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Kira/Aidat",
    key: "rentOrSubscriptionAmount",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Ödenen",
    key: "amount",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Kalan",
    key: "rentOrSubscriptionRemainAmount",
    width: "minmax(160px,1fr)",
  },
];

export const expenseColumns: IBaseColumns[] = [
  { title: "Gider Kalemi Adı", key: "name", width: "minmax(160px,1fr)" },
  {
    title: "Toplam Borç $",
    key: "debtAmountUsd",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Borç ₺",
    key: "debtAmountTl",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Giderler $",
    key: "amountUsd",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Giderler ₺",
    key: "amountTl",
    width: "minmax(160px,1fr)",
  },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: 132 },
];

export const revenueColumns: IBaseColumns[] = [
  { title: "Gelir Kalemi Adı", key: "name", width: "minmax(160px,1fr)" },
  {
    title: "Toplam Gelirler $",
    key: "amountUsd",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Toplam Gelirler ₺",
    key: "amountTl",
    width: "minmax(160px,1fr)",
  },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: 132 },
];

export const propertyColumns: IBaseColumns[] = [
  { title: "Mağaza", key: "propertyName", width: "minmax(100px,150px)" },
  { title: "Şirket", key: "company", width: "minmax(200px,1fr)" },
  {
    title: "Kiracı",
    key: "tenantNameSurname",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Başlangıç Tarihi",
    key: "startDate",
    width: "minmax(60px,200px)",
  },
  {
    title: "Bitiş Tarihi",
    key: "endDate",
    width: "minmax(60px,200px)",
  },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: 132 },
];

export const storeColumns: IBaseColumns[] = [
  { title: "Depo", key: "storeName", width: "minmax(100px,150px)" },
  { title: "Şirket", key: "company", width: "minmax(200px,1fr)" },
  {
    title: "Kiracı",
    key: "tenantNameSurname",
    width: "minmax(160px,1fr)",
  },
  {
    title: "Başlangıç Tarihi",
    key: "startDate",
    width: "minmax(60px,200px)",
  },
  {
    title: "Bitiş Tarihi",
    key: "endDate",
    width: "minmax(60px,200px)",
  },
  { title: "Aksiyonlar", key: "action", fixed: "right", width: 132 },
];
